import { FC, useMemo } from "react";
import { useDidMount } from "rooks";
import { Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { getOffHoursRecommendationsThunk } from "@/store/recommendations/thunks/off-hours/data-get/getOffHoursRecommendationsThunk";
import { recommendationsDataGridDataSelector } from "@/store/recommendations/selectors/off-hours/data/recommendationsDataGridDataSelector";
import { OffHoursRecommendationsSubRow } from "@/components/pages/recommendations/components/off-hours-recommendations/components/table/subrow/OffHoursRecommendationsSubRow";

interface ResourceDetailsOpportunityOffHoursContentProps {
  recommendationId: string;
}

export const ResourceDetailsOpportunityOffHoursContent: FC<
  ResourceDetailsOpportunityOffHoursContentProps
> = ({ recommendationId }) => {
  const dispatch = useAppDispatch();

  const computeData = useAppSelector((state) =>
    recommendationsDataGridDataSelector(state, "compute"),
  );
  const dbData = useAppSelector((state) =>
    recommendationsDataGridDataSelector(state, "database"),
  );

  const recommendation = useMemo(() => {
    if (!dbData.length && !computeData.length) {
      return;
    }

    return [...computeData, ...dbData].find(
      (rec) => rec.id === recommendationId,
    );
  }, [computeData, dbData, recommendationId]);

  useDidMount(() => {
    dispatch(getOffHoursRecommendationsThunk({ group: "database" }));
    dispatch(getOffHoursRecommendationsThunk({ group: "compute" }));
  });

  if (!recommendation) {
    return null;
  }

  return (
    <Box
      p={2}
      border={1}
      bgcolor="white"
      borderRadius={3}
      borderColor="grey.300"
    >
      <OffHoursRecommendationsSubRow data={recommendation} chartHeight={300} />
    </Box>
  );
};
